import React from 'react';
import { Button, Card, CardBody, Col, Row } from 'reactstrap';
import { MdBlock } from 'react-icons/md';
import { useHistory } from 'react-router-dom';
import Page from '../components/Page';

const PermissionDeniedPage = () => {
    const history = useHistory();

    return (
        <Page title="Access Denied" className="d-flex align-items-center justify-content-center" style={{ minHeight: '60vh' }}>
            <Row>
                <Col md={12} className="mx-auto">
                    <Card className="flex-row border-0 text-center">
                        <CardBody>
                            <div className="mb-4">
                                <MdBlock size={80} color="#dc3545" />
                            </div>
                            <h2 className="mb-4">Access Denied</h2>
                            <p className="lead mb-4">
                                You do not have permission to view this page. This area is restricted to administrators only.
                            </p>
                            <div className="d-flex justify-content-center gap-3">
                                <Button color="primary" onClick={() => history.push('/dashboard')}>
                                    Go to Dashboard
                                </Button>
                                <Button color="secondary" outline onClick={() => history.goBack()} className="ml-3">
                                    Go Back
                                </Button>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Page>
    );
};

export default PermissionDeniedPage;
